import React, { useMemo } from 'react';
import head from 'lodash/head';
import { useSelector } from 'react-redux';
import { Accordion, LIGHT_ACCORDION } from '@yme/atoms/accordion';
import { buildAccordionData } from '@yme/components/Destinations/ExperienceDetailsPage/components/ExperienceDetailsCard/components/Description/helpers';
import { getExperienceDetailsPageState } from '@yme/components/Destinations/ExperienceDetailsPage/redux/selectors';
import { getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { CIRCUIT } from './constants';
export function Description() {
    const isRightToLeft = useSelector(getRTL);
    const { expDescription, expEquipment, expType, partnerRecommendation, itinerary, expIncluded } = useSelector(getExperienceDetailsPageState);
    const { t } = useTranslation();
    const isCircuit = expType.length === 1 && head(expType) === CIRCUIT;
    const whatsIncluded = expIncluded.map(({ html }) => html).join('');
    const data = useMemo(() => [
        {
            title: t('destinations_experienceDescription_label'),
            content: expDescription?.html,
        },
        {
            title: t('destinations_experienceEquipment_label'),
            content: expEquipment?.html,
        },
        {
            title: t('destinations_experiencePartnerRecommendation_label'),
            content: partnerRecommendation?.html,
        },
        {
            title: isCircuit
                ? t('destinations_experienceSchedule_label')
                : expType.length > 1
                    ? t('destinations_experienceAdditionalInfo_label')
                    : t('destinations_experienceItinerary_label'),
            content: itinerary?.html,
        },
        {
            title: t('destinations_experienceIncluded_label'),
            content: whatsIncluded,
        },
    ], [
        expDescription?.html,
        expEquipment?.html,
        expType.length,
        isCircuit,
        itinerary?.html,
        partnerRecommendation?.html,
        t,
        whatsIncluded,
    ]);
    const accordionData = useMemo(() => buildAccordionData(data, isRightToLeft), [data, isRightToLeft]);
    return (React.createElement(Accordion, { isRightToLeft: isRightToLeft, data: accordionData, colorScheme: LIGHT_ACCORDION, preOpenedIndex: 0 }));
}
